import { render, staticRenderFns } from "./gallery-photo-list.vue?vue&type=template&id=c2be93a2&scoped=true&"
import script from "./gallery-photo-list.vue?vue&type=script&lang=js&"
export * from "./gallery-photo-list.vue?vue&type=script&lang=js&"
import style0 from "./gallery-photo-list.vue?vue&type=style&index=0&id=c2be93a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2be93a2",
  null
  
)

export default component.exports